// Export de tous les services API
export { default as api } from './api';
export { default as authService } from './authService';
export { default as missionService } from './missionService';
export { default as userService } from './userService';
export { default as organizationService } from './organizationService';
export { default as messageService } from './messageService';
export { default as applicationService } from './applicationService';

// Export groupé pour faciliter l'importation
export const services = {
  auth: require('./authService').default,
  mission: require('./missionService').default,
  user: require('./userService').default,
  organization: require('./organizationService').default,
  message: require('./messageService').default,
  application: require('./applicationService').default,
};